export const UserWithLaptopIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
    <path
      d="M27 13.5C27 20.96 20.96 27 13.5 27C6.04 27 0 20.96 0 13.5C0 6.04 6.04 0 13.5 0C20.96 0 27 6.04 27 13.5Z"
      fill="#19282D"
    />
    <path
      d="M4.65 18.94C4.65 15.4652 7.35543 12.6445 10.6882 12.6445C11.9429 12.6445 13.0995 13.0431 14.0602 13.7176"
      stroke="white"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
    <path
      d="M14.3444 8.82226C14.3444 10.9276 12.7075 12.6445 10.6784 12.6445C8.64932 12.6445 7.01234 10.9378 7.01234 8.82226C7.01234 6.70673 8.64932 5 10.6784 5C12.7075 5 14.3444 6.70673 14.3444 8.82226Z"
      stroke="white"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
    <path
      d="M14.9326 6.80893C15.6187 6.40013 16.4127 6.17529 17.2557 6.17529C19.8729 6.17529 22 8.3828 22 11.1217C22 12.1948 21.6765 13.176 21.1178 13.9833"
      stroke="white"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
    <path
      d="M18.5104 18.94H11.0999L14.5895 15.1075H22L18.5104 18.94Z"
      stroke="white"
      strokeWidth="0.5"
      strokeMiterlimit="10"
    />
    <path d="M7.58088 18.94H14.6189" stroke="white" strokeWidth="0.5" strokeMiterlimit="10" />
    <path d="M17.1675 8.42368V11.1217H20.4512" stroke="white" strokeWidth="0.5" strokeMiterlimit="10" />
    <rect x="15" y="5" width="8" height="9" fill="#19282D" />
  </svg>
)
